export const categories = [
  {
    id: 1,
    name: 'Shoes',
    namePt: 'Tênis',
    desc: 'Os sneakers mais procurados do CSSBuy spreadsheet com atualização diária de lançamentos exclusivos.',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Clean%20editorial%20product%20photography%20of%20a%20pair%20of%20white%20and%20cream%20athletic%20sneakers%20placed%20on%20a%20warm%20textured%20stone%20surface%20with%20soft%20morning%20light%20casting%20gentle%20shadows%20minimalist%20composition%20neutral%20earth%20tones&width=400&height=300&seq=cat-v2-shoes-001&orientation=landscape',
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    namePt: 'Moletons',
    desc: 'Moletons e suéteres com designs exclusivos encontrados no CSSBuy spreadsheet atualizado.',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20photography%20of%20a%20cozy%20charcoal%20grey%20hoodie%20draped%20over%20a%20wooden%20chair%20in%20a%20bright%20room%20with%20warm%20natural%20window%20light%20and%20a%20cream%20wall%20background%20editorial%20minimalist%20style&width=400&height=300&seq=cat-v2-hoodies-002&orientation=landscape',
  },
  {
    id: 3,
    name: 'T-Shirts',
    namePt: 'Camisetas',
    desc: 'Camisetas com estampas únicas e edições limitadas de streetwear no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20photography%20of%20a%20soft%20cotton%20t-shirt%20in%20a%20warm%20terracotta%20shade%20neatly%20folded%20on%20a%20light%20linen%20fabric%20surface%20with%20diffused%20natural%20sunlight%20clean%20editorial%20composition&width=400&height=300&seq=cat-v2-tshirts-003&orientation=landscape',
  },
  {
    id: 4,
    name: 'Jackets',
    namePt: 'Jaquetas',
    desc: 'Jaquetas casuais e esportivas das melhores marcas disponíveis no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20editorial%20photography%20of%20a%20lightweight%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20warm%20taupe%20painted%20wall%20with%20gentle%20side%20lighting%20elegant%20composition&width=400&height=300&seq=cat-v2-jackets-004&orientation=landscape',
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    namePt: 'Calças/Bermudas',
    desc: 'Calças e bermudas estilosas com os melhores preços no CSSBuy spreadsheet diário.',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20tailored%20beige%20linen%20trousers%20elegantly%20draped%20over%20a%20light%20wooden%20surface%20with%20soft%20natural%20sunlight%20from%20a%20nearby%20window%20minimalist%20editorial%20catalog%20style&width=400&height=300&seq=cat-v2-pants-005&orientation=landscape',
  },
  {
    id: 6,
    name: 'Headwear',
    namePt: 'Acessórios de Cabeça',
    desc: 'Bonés, gorros e chapéus estilosos com preços imbatíveis no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20classic%20baseball%20cap%20in%20warm%20sand%20color%20resting%20on%20a%20smooth%20concrete%20surface%20with%20soft%20afternoon%20light%20creating%20a%20subtle%20shadow%20clean%20editorial%20style&width=400&height=300&seq=cat-v2-headwear-006&orientation=landscape',
  },
  {
    id: 7,
    name: 'Sets',
    namePt: 'Conjuntos',
    desc: 'Conjuntos coordenados de streetwear e moda casual no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20photography%20of%20a%20perfectly%20matched%20coord%20set%20in%20warm%20neutral%20earth%20tones%20beautifully%20arranged%20on%20a%20textured%20cream%20wool%20blanket%20with%20gentle%20natural%20lighting%20editorial%20composition&width=400&height=300&seq=cat-v2-sets-007&orientation=landscape',
  },
  {
    id: 8,
    name: 'Underwear/Underpants',
    namePt: 'Roupa Íntima',
    desc: 'Roupas íntimas de qualidade com preços acessíveis no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20soft%20organic%20cotton%20underwear%20in%20a%20warm%20mocha%20shade%20neatly%20folded%20on%20a%20smooth%20bamboo%20surface%20with%20soft%20diffused%20morning%20light%20minimalist%20editorial%20style&width=400&height=300&seq=cat-v2-underwear-008&orientation=landscape',
  },
  {
    id: 9,
    name: 'Jersey',
    namePt: 'Camisas Esportivas',
    desc: 'Camisas esportivas e jerseys de times internacionais no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20product%20photography%20of%20a%20soccer%20jersey%20in%20warm%20burgundy%20and%20cream%20stripes%20laid%20flat%20on%20a%20light%20grey%20concrete%20surface%20with%20dramatic%20side%20lighting%20editorial%20clean%20composition&width=400&height=300&seq=cat-v2-jersey-009&orientation=landscape',
  },
  {
    id: 10,
    name: 'Accessories',
    namePt: 'Acessórios',
    desc: 'Acessórios de moda masculina e feminina com os melhores preços no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20photography%20of%20stylish%20fashion%20accessories%20including%20sunglasses%20and%20a%20minimalist%20watch%20in%20warm%20gold%20and%20brown%20tones%20on%20a%20cream%20marble%20surface%20with%20soft%20natural%20light&width=400&height=300&seq=cat-v2-accessories-010&orientation=landscape',
  },
  {
    id: 11,
    name: 'Bags',
    namePt: 'Bolsas',
    desc: 'Bolsas e mochilas de marcas premium com preços acessíveis no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20stylish%20leather%20tote%20bag%20in%20rich%20cognac%20brown%20placed%20on%20a%20light%20oak%20wooden%20table%20with%20warm%20natural%20sunlight%20streaming%20from%20the%20side%20editorial%20catalog%20style&width=400&height=300&seq=cat-v2-bags-011&orientation=landscape',
  },
  {
    id: 12,
    name: 'Belts',
    namePt: 'Cintos',
    desc: 'Cintos de couro premium e designs modernos disponíveis no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20handcrafted%20leather%20belt%20with%20a%20brushed%20brass%20buckle%20elegantly%20coiled%20on%20a%20smooth%20warm%20grey%20stone%20surface%20with%20soft%20top%20down%20lighting%20editorial%20composition&width=400&height=300&seq=cat-v2-belts-012&orientation=landscape',
  },
  {
    id: 13,
    name: 'Perfumes',
    namePt: 'Perfumes',
    desc: 'Perfumes importados e fragrâncias exclusivas com preços especiais no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20a%20luxury%20perfume%20bottle%20with%20warm%20amber%20colored%20liquid%20placed%20on%20a%20dark%20wooden%20surface%20surrounded%20by%20dried%20flowers%20with%20soft%20candlelight%20warm%20atmosphere&width=400&height=300&seq=cat-v2-perfumes-013&orientation=landscape',
  },
  {
    id: 14,
    name: 'Other Stuff',
    namePt: 'Outros Itens',
    desc: 'Diversos itens de lifestyle e utilidades com preços imperdíveis no CSSBuy spreadsheet.',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20photography%20of%20various%20stylish%20everyday%20carry%20items%20including%20a%20wallet%20keychain%20and%20notebook%20beautifully%20arranged%20on%20a%20warm%20cream%20linen%20surface%20editorial%20composition&width=400&height=300&seq=cat-v2-other-014&orientation=landscape',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';